import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { PublicMultiCertificatesService } from '@core/services/public-multi-certificate/public-multi-certificate.service';

import { HttpErrorResponse } from '@angular/common/http';
import { PublicCertificate } from '@core/models/public-certificate.model';
import { PublicMultiCertificate } from '@core/models/public-multi-certificate.model';
import { ErrorMessages } from '@shared/models/error-messages.model';

import { INITIAL_PAGE_ERRORS } from '@shared/consts/errors';

@Component({
  selector: 'fdx-public-multi-certificate',
  templateUrl: './public-multi-certificate.component.html',
  host: { class: 'd-flex flex-column h-100' }
})
export class PublicMultiCertificateComponent implements OnInit {
  publicMultiCertificate: PublicMultiCertificate;
  isLoading: boolean = false;
  responseErrors: ErrorMessages = INITIAL_PAGE_ERRORS;

  constructor(
    private route: ActivatedRoute,
    private publicMultiCertificatesService: PublicMultiCertificatesService
  ) {}

  ngOnInit(): void {
    this.getPublicMultiCertificate();
  }

  onDownloadCertificate(certificate: PublicCertificate): void {
    this.initializeRequest();
    this.publicMultiCertificatesService
      .downloadCertificate(certificate.id)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (file: any) => {
          const blob = this.dataURItoBlob(file);
          saveAs(blob, `FILE_${certificate.id}.${blob.type.split('/')[1]}`);
        },
        (error: HttpErrorResponse) => (this.responseErrors = error.error)
      );
  }

  private dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  private getPublicMultiCertificate(): void {
    const multiCertificateId = this.route.snapshot.paramMap.get('id');

    this.initializeRequest();
    this.publicMultiCertificatesService
      .getDetail(multiCertificateId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (multiCertificate: PublicMultiCertificate) =>
          (this.publicMultiCertificate = multiCertificate),
        (error: HttpErrorResponse) => (this.responseErrors = error.error)
      );
  }

  private initializeRequest(): void {
    this.isLoading = true;
    this.responseErrors = INITIAL_PAGE_ERRORS;
  }
}
